module.exports = __webpack_public_path__ + "img/cog-primary.d85831a9.svg";